import { useStats } from '@/hooks/use-stats'
import { usePhenotypes } from '@/hooks/use-phenotypes'
import { StatsCard } from '@/components/dashboard/StatsCard'
import { RecentRuns } from '@/components/dashboard/RecentRuns'
import { QuickActions } from '@/components/dashboard/QuickActions'
import { SystemHealth } from '@/components/dashboard/SystemHealth'
import { List, CheckCircle, Clock, Layers } from 'lucide-react'

export function Dashboard() {
  const { data: stats, isLoading: statsLoading } = useStats()
  const { data: phenotypes } = usePhenotypes()

  // Calculate phenotype count from phenotypes list if stats endpoint not available
  const phenotypeCount = stats?.phenotypeCount ?? phenotypes?.length ?? 0

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Dashboard</h1>
        <p className="text-muted-foreground">
          Overview of your extraction jobs and system health
        </p>
      </div>

      {/* Stats cards grid */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard
          title="Total Runs"
          value={statsLoading ? '-' : (stats?.totalRuns ?? 0)}
          description="All-time extractions"
          icon={<List className="h-4 w-4" />}
        />
        <StatsCard
          title="Success Rate"
          value={statsLoading ? '-' : `${stats?.successRate ?? 0}%`}
          description="Successful completions"
          icon={<CheckCircle className="h-4 w-4" />}
        />
        <StatsCard
          title="Active Jobs"
          value={statsLoading ? '-' : (stats?.activeJobs ?? 0)}
          description="Currently processing"
          icon={<Clock className="h-4 w-4" />}
        />
        <StatsCard
          title="Phenotypes"
          value={phenotypeCount}
          description="Detected patterns"
          icon={<Layers className="h-4 w-4" />}
        />
      </div>

      {/* Quick actions */}
      <QuickActions />

      {/* Recent runs and system health in 2-column layout */}
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <RecentRuns />
        </div>
        <div>
          <SystemHealth />
        </div>
      </div>
    </div>
  )
}
